import { Pipe, PipeTransform } from '@angular/core';
import { ComparatorService } from '../../services/comparator-service';
import { LastRechtGrundstueckEntryMeta } from '../../../core/gb-api';

@Pipe({
  name: 'orderByGrundstuecknummer'
})
export class OrderByGrundstuecknummerPipe implements PipeTransform {
  public constructor(private comperatorService: ComparatorService) {}

  transform(array, ascending = true, propertyName = 'grundstueck'): Array<LastRechtGrundstueckEntryMeta> | any {
    if (ascending) {
      return Array.from(array).sort((item1: any, item2: any) => {
        if (propertyName && item1[propertyName]) {
          return this.comperatorService.grundstueckComparator(item1[propertyName], item2[propertyName]);
        } else {
          return this.comperatorService.grundstueckComparator(item1, item2);
        }
      });
    } else {
      return Array.from(array).sort((item1: any, item2: any) => {
        if (propertyName && item1[propertyName]) {
          return this.comperatorService.grundstueckComparator(item2[propertyName], item1[propertyName]);
        } else {
          return this.comperatorService.grundstueckComparator(item2, item1);
        }
      });
    }
  }
}
